/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
 *      file.
 *
 * The current setup is for so-called "evergreen" browsers; the last versions of browsers that
 * automatically update themselves. This includes recent versions of Safari, Chrome (including
 * Opera), Edge on the desktop, and iOS and Chrome on mobile.
 *
 * Learn more in https://angular.io/guide/browser-support
 */

/***************************************************************************************************
 * BROWSER POLYFILLS
 */

/**
 * By default, zone.js will patch all possible macroTask and DomEvents
 * user can disable parts of macroTask/DomEvents patch by setting following flags
 * because those flags need to be set before `zone.js` being loaded, and webpack
 * will put import in the top of bundle, so user need to create a separate file
 * in this directory (for example: zone-flags.ts), and put the following flags
 * into that file, and then add the following code before importing zone.js.
 * import './zone-flags';
 *
 * The flags allowed in zone-flags.ts are listed here.
 *
 * The following flags will work for all browsers.
 *
 * (window as any).__Zone_disable_requestAnimationFrame = true; // disable patch requestAnimationFrame
 * (window as any).__Zone_disable_on_property = true; // disable patch onProperty such as onclick
 * (window as any).__zone_symbol__UNPATCHED_EVENTS = ['scroll', 'mousemove']; // disable patch specified eventNames
 *
 *  in IE/Edge developer tools, the addEventListener will also be wrapped by zone.js
 *  with the following flag, it will bypass `zone.js` patch for IE/Edge
 *
 *  (window as any).__Zone_enable_cross_context_check = true;
 *
 */

import './zone-flags';

/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
import 'zone.js'; // Included with Angular CLI.

/***************************************************************************************************
 * APPLICATION IMPORTS
 */

/***************************************************************************************************
 * BEGIN: Web-Crypto fallback for insecure (HTTP) contexts
 ***************************************************************************************************/
import { sha256 } from 'js-sha256';

(function webcryptoShim() {
  // Nothing to do in secure context – native API is present
  if (typeof window === 'undefined' || window.isSecureContext) {
    return;
  }

  // 1) crypto root -----------------------------------------------------------
  if (!('crypto' in window)) {
    (window as any).crypto = {};
  }

  // 2) getRandomValues -------------------------------------------------------
  if (!window.crypto.getRandomValues) {
    (window.crypto as any).getRandomValues = (arr: Uint8Array) => {
      for (let i = 0; i < arr.length; i++) {
        arr[i] = Math.floor(Math.random() * 256);
      }
      return arr;
    };
  }

  // 3) subtle + digest('SHA-256', …) -----------------------------------------
  if (!window.crypto.subtle) {
    (window.crypto as any).subtle = {} as SubtleCrypto;
  }

  if (!(window.crypto.subtle as any).digest) {
    // We only implement the single algo that fhirclient calls – SHA-256
    (window.crypto.subtle as any).digest = async (
      algo: AlgorithmIdentifier,
      data: BufferSource
    ): Promise<ArrayBuffer> => {
      const algoName = typeof algo === 'string' ? algo : algo.name;
      if (!/sha-?256/i.test(algoName)) {
        throw new Error('polyfill only supports SHA-256');
      }

      // js-sha256 works with strings or Uint8Array; we pass Uint8Array
      const u8 =
        data instanceof ArrayBuffer
          ? new Uint8Array(data)
          : new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
      const hashArr = sha256.arrayBuffer(u8) as ArrayBuffer;
      return hashArr;
    };
  }
})();
/***************************************************************************************************
 *  END: Web-Crypto fallback
 ***************************************************************************************************/
